// extracted by mini-css-extract-plugin
module.exports = {"root":"WvoF2AmZ"};